import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import type { CompanyMutationData } from "../apis/interfaces/common";
import { Modal } from "react-bootstrap";

interface CompanyFormProps {
  initialValues: CompanyMutationData;
  onSubmit: any;
  onCancel: any;
}

const validationSchema = Yup.object({
  company: Yup.string().required("Company name is required"),
  company_code: Yup.string().required("Company code is required"),
});

const CompanyForm = (props: CompanyFormProps) => {
  const { initialValues, onSubmit, onCancel } = props;
  const handleSubmit = (
    values: CompanyMutationData,
    { setStatus }: FormikHelpers<CompanyMutationData>
  ) => {
    try {
      validationSchema.validateSync(values, { abortEarly: false });
      onSubmit(values);
    } catch (errors) {
      setStatus("An error occurred during form submission.");
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ handleChange, handleSubmit, isSubmitting, isValid }) => (
        <>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <div className="form-group mb-2">
                <label htmlFor="company">Company Name:</label>
                <Field
                  type="text"
                  id="company"
                  name="company"
                  className="form-control"
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="company"
                  component="div"
                  className="error-message text-danger"
                />
              </div>

              <div className="form-group mb-2">
                <label htmlFor="company">Code:</label>
                <Field
                  type="text"
                  id="company_code"
                  name="company_code"
                  className="form-control"
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="company_code"
                  component="div"
                  className="error-message text-danger"
                />
              </div>

              <div className="form-check mb-2">
                <Field
                  type="checkbox"
                  id="active"
                  name="active"
                  className="form-check-input"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="active">
                  Active
                </label>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <button
                  onClick={onCancel}
                  className="btn btn-sm btn-danger mx-3"
                  type="button"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-success"
                  disabled={!(!isSubmitting && isValid)}
                >
                  Save
                </button>
              </div>
            </Modal.Footer>
          </Form>
        </>
      )}
    </Formik>
  );
};

export default CompanyForm;
